import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const toggleVariants = cva(
  "pressable inline-flex items-center justify-center gap-2 rounded-control text-sm font-medium text-ink-muted hover:bg-paper-100 hover:text-ink disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-paper-200 data-[state=on]:text-ink data-[state=on]:ring-2 data-[state=on]:ring-emerald-700 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "bg-paper-50 ring-1 ring-paper-300 hover:bg-paper-100",
      },
      size: {
        default: "size-10",
        sm: "size-9",
        lg: "size-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
